import { ConfirmDialog } from "@/components/ui/ConfirmDialog";
import { useTranslation } from "@/packages/utils";
import { Timer } from "lucide-react";

interface SessionTimeoutWarningProps {
  open: boolean;
  secondsRemaining: number;
  onExtend: () => void;
  onLogout: () => void;
}

function formatTime(totalSeconds: number): string {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
}

export function SessionTimeoutWarning({
  open,
  secondsRemaining,
  onExtend,
  onLogout,
}: SessionTimeoutWarningProps) {
  const { t } = useTranslation(["common"]);

  return (
    <ConfirmDialog open={open} onClose={onExtend} forced>
      <ConfirmDialog.Title>
        <span className="flex items-center gap-2">
          <Timer size={18} className="text-warning" />
          {t("sessionTimeout.title")}
        </span>
      </ConfirmDialog.Title>

      <ConfirmDialog.Body>
        <p>{t("sessionTimeout.message")}</p>
        <p className="mt-3 text-center text-2xl font-mono font-semibold tabular-nums text-primary">
          {formatTime(Math.max(0, secondsRemaining))}
        </p>
      </ConfirmDialog.Body>

      <ConfirmDialog.Actions
        onConfirm={onExtend}
        onCancel={onLogout}
        confirmLabel={t("sessionTimeout.extend")}
        cancelLabel={t("sessionTimeout.logout")}
      />
    </ConfirmDialog>
  );
}
